import React from "react";

export default function EmptyState({ icon: Icon, title, hint, action, testid }) {
  return (
    <div
      className="bg-white border border-dashed border-[#D2CEC1] p-12 text-center"
      data-testid={testid || "empty-state"}
    >
      {Icon && (
        <div className="mx-auto w-12 h-12 border border-[#1F1E1B] flex items-center justify-center mb-4">
          <Icon className="w-5 h-5 text-[#1F1E1B]" strokeWidth={2.2} />
        </div>
      )}
      <h3 className="font-display text-lg font-bold text-[#1F1E1B]">{title}</h3>
      {hint && <p className="text-sm text-[#66645E] mt-1 max-w-sm mx-auto">{hint}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
